import React from 'react';
import {I18nFunction, I18nKFunction} from 'i18n';

export interface TranslationUtils {
    i18n: I18nFunction;
    i18nK?: I18nKFunction;
}

export default React.createContext<TranslationUtils>({i18n: () => ''});
